<div class="carousel-row relative group">
  <div class="carousel-clip">
    <div class="keen-slider" #sliderRef>
      <ng-content></ng-content>
    </div>
  </div>

  <button
    (click)="prev()"
    class="arrow-hover-scale-wrapper absolute top-1/2 left-0 -translate-y-1/2 z-10 bg-white rounded-lg py-2 px-3 shadow opacity-0 pointer-events-none transition-opacity duration-200 group-hover:opacity-100 group-hover:pointer-events-auto"
  >
    <img
      class="arrow-hover-scale"
      [src]="assetUrl + 'icons/arrow-left-20.svg'"
      alt="Previous"
    />
  </button>

  <button
    (click)="next()"
    class="arrow-hover-scale-wrapper absolute top-1/2 right-0 -translate-y-1/2 z-10 bg-white rounded-lg py-2 px-3 shadow opacity-0 pointer-events-none transition-opacity duration-200 group-hover:opacity-100 group-hover:pointer-events-auto"
  >
    <img
      class="arrow-hover-scale"
      [src]="assetUrl + 'icons/arrow-right-20.svg'"
      alt="Next"
    />
  </button>
</div>

<div class="flex justify-center mt-4 gap-1">
  <div
    *ngFor="let idx of dots"
    class="w-2 h-2 rounded-full mx-1 cursor-pointer"
    [class.bg-purple-600]="idx === currentSlide"
    [class.bg-gray-300]="idx !== currentSlide"
    (click)="moveToSlide(idx)"
  ></div>
</div>
